export enum UserConnectionState {
  UNKNOWN = 'unknown',
  NOT_CONNECTED = 'notConnected',
  CONNECTED = 'connected'
}

export interface User {
  uid?: string
  id?: string // For compatibility with React stores
  firstName: string
  lastName: string
  email: string
  userConnectionState: UserConnectionState
  phone?: string
  isNewUser: boolean
  isAdmin: boolean
  createdAt?: string
  // Computed properties
  initials?: string
  name?: string // Computed from firstName + lastName
  role?: 'admin' | 'user' // Computed from isAdmin
}

export interface LoginCredentials {
  email: string
  password: string
}

export interface AuthResponse {
  user: User
  token: string
}